import axios from 'axios'
import router from "../router";
import {isLoggedIn} from "@/utils/authFunctions"
import { useAuthStore } from '@/stores/auth'

axios.defaults.withCredentials = true

axios.interceptors.response.use((response) => {
  if(response.data != null && Object.keys(response.data).includes('redirectURL')){
    document.location = response.data.redirectURL
  }
  return response;
}, (error) => {
  if(error && 'response' in error && error.response) {
    if(error.response.status === 401){
      if(isLoggedIn()){
        document.cookie = 'loggedIn' +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
      }
      router.push('/?next=' +  window.location.pathname)
    }else if(error.response.status === 403){
      if(router.currentRoute.path.includes('admin') && router.currentRoute.path !== '/admin' && router.currentRoute.path !== '/admin/'){
        router.push('/admin')
      }else if(router.currentRoute.path !== '/' && router.currentRoute.path !== '/' && !router.currentRoute.path.includes('admin')){
        router.push('/')
      }
    }else if(error.response.status === 400){
      console.log(error.response.data)
    }else if(error.response.status >= 500){
      console.error('API request failed', error.response.data)
    }
  } else {
    console.error('API request failed', error)
  }
    return Promise.reject(error);
});

const getHost = () => {
  const hostname = window.location.hostname

  let port = '8080'
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return `http://${hostname}:${port}`
  } else {
    return ''
  }
}

const host = getHost()

export default {
  apiCall: async (method, prefix, path, data=null) => {
    const url = `${host}/${prefix}/${path}`
    const authStore = useAuthStore()
    let companyId = authStore.companyId
    if(companyId !== null && companyId !== undefined){
      if(method === 'GET'){
        if(data !== null){
          data = data + `&companyId=${companyId}`
        }else{
          data = `companyId=${companyId}`
        }
      }else{
        if(data !== null){
          data['companyId'] = companyId
        }else{
          data = {'companyId': companyId}
        }
      }
    }
    if(method === 'GET'){
      if (data !== null){
        return (await axios.get(url + `?${data}`)).data
      }else{
      return (await axios.get(url)).data
      }
    }else if(method === 'POST'){
      if (data !== null){
        return (await axios.post(url, data)).data
      }else{
        return (await axios.post(url)).data
      }
    }else if(method === 'PUT'){
      if (data !== null){
        return (await axios.put(url, data)).data
      }else{
        return (await axios.put(url)).data
      }
    }else if(method === 'DELETE'){
      if (data !== null){
        return (await axios.delete(url, data)).data
      }else{
        return (await axios.delete(url)).data
      }
    }else{
      console.log('METHOD NOT SUPPORTED')
      return {'data': 'METHOD NOT SUPPORTED'}
    }
  }
}



